import 'owl.carousel';

function initSlider(slider) {
    
    /*
    *   This site uses Owl Carousel
    *   For documentation on events and other options please refer to their documentation
    *   https://owlcarousel2.github.io/OwlCarousel2/
    */
    
    var slider = $(slider);
    if(slider.length) { 
        slider.each(function(id) {
            var customOptions;
            var sliderParams
            var sliderType = $(this).data('type');
            var isMobile = $(this).data('mobile-only');
            
            // Default options/params for thew slider.
            // Define custom classes to be used for the slider.
            var defaultOptions = {
                refreshClass: 'slider__refresh',
                loadedClass: 'slider__loaded',
                loadingClass: 'slider__loading',
                responsiveClass: 'slider__responsive',
                dragClass: 'slider__drag',
                itemClass: 'slider__item',
                stageClass: 'slider__stage',
                stageOuterClass: 'slider__stage-outer',
                grabClass: 'slider__grab',
                autoHeightClass: 'slider__height',
                navContainerClass: 'slider__nav',
                navClass: [ 'slider__btn slider__prev', 'slider__btn slider__next' ],
                navText: [ '<span class="icon-arrow-left icon-18" aria-label="Previous"></span>', '<span class="icon-arrow-right icon-18" aria-label="Next"></span>' ],
                dotClass: 'slider__dot',
                dotsClass: 'slider__dots',
            }

            // Function to determine events for slider that has mobile data attr
            var sliderMobile = function(slider, params) {
                var windowSize = 990;
                
                $(document).ready(function() {
                    if ( $(window).width() < windowSize ) {
                        slider.owlCarousel(params);
                    } else {
                        slider.trigger('destroy.owl.carousel');
                    }
                });

                $(window).resize(function() {
                    if ( $(window).width() < windowSize ) {
                        slider.owlCarousel(params);
                    } else {
                        slider.trigger('destroy.owl.carousel');
                    }
                });
            };
            
            // Function to setup slide accessibility when initialized
            var sliderAccessibility = function(slider, e) {
                slider.find('.slider__item').attr('aria-selected','false');
                slider.find('.slider__item.active').attr('aria-selected','true');

                // apply meta info to next and previous buttons and make them focusable
                slider.find('.slider__prev').attr({
                    role: 'button',
                    title: 'Previous',
                    tabindex: '0',
                });
                slider.find('.slider__next').attr({
                    role: 'button',
                    title: 'Next',
                    tabindex: '0',
                }); 
            };
            
            // Custom options depending on the data-type atrtribute placed on the '.js-slider' element
            // If no attribute is defined refer to the default case
            switch (sliderType) {
                case 'mobile':
                    customOptions = {
                        center: true,
                        loop: false,
                        nav: false,
                        items:1,
                        margin:0,
                        dots: true,
                        responsive : {
                            660 : {
                                items:2,
                                center: false,
                            }
                        }
                    }
                    break;
                case 'multi':
                    customOptions = {
                        loop: false,
                        nav: false,
                        items:1,
                        dots: true,
                        margin: 20,
                        stagePadding: 40,
                        responsive : {
                            768 : {
                                items:2,
                                dots: true,
                                nav: false,
                                margin: 40,
                                stagePadding: 120,
                                
                            },
                            960 : {
                                items:1,
                                dots: false,
                                nav: true,
                                margin: 40,
                                stagePadding: 120,
                                
                            },
                            1200 : {
                                items:2,
                                dots: false,
                                nav: true,
                                stagePadding: 100,
                            },
                            1650 : {
                                items:3,
                                dots: false,
                                nav: true,
                                stagePadding: 60,
                            }
                        }
                    }
                    break;
                case 'quote':
                    customOptions = {
                        loop: false,
                        nav: true,
                        items:1,
                        dots: true,
                        margin: 20,
                        stagePadding: 40,
                        responsive : {
                            768 : {
                                items:2,
                                dots: true,
                                nav: true,
                                margin: 40,
                                stagePadding: 120,
                                
                            },
                            960 : {
                                items:1,
                                dots: false,
                                nav: true,
                                margin: 40,
                                stagePadding: 120,
                                
                            },
                            1200 : {
                                items:1,
                                dots: false,
                                nav: true,
                                stagePadding: 120,
                            },
                            1650 : {
                                items:1,
                                dots: false,
                                nav: true,
                                stagePadding: 120,
                            }
                        }
                    }
                    break;
                case 'quote-custom-nav-positioning':
                    customOptions = {
                        loop: false,
                        nav: false,
                        items: 1,
                        dots: true,
                        margin: 20,
                        stagePadding: 0,
                        responsive : {
                            768 : {
                                items:2,
                                dots: true,
                                margin: 40,
                                
                            },
                            960 : {
                                items:1,
                                dots: false,
                                margin: 40,
                                
                            },
                            1200 : {
                                items:1,
                                dots: false,
                            },
                            1650 : {
                                items:1,
                                dots: false,
                            }
                        }
                    }
                    break;
                case 'textOnly':
                    customOptions = {
                        items: 1,
                        margin:0,
                        nav: true,
                        dots: true,
                        loop: true,
                        autoHeight:true,
                        stagePadding: 0,
                        navClass: [ 'slider__btn slider__prev', 'slider__btn slider__next' ]
                    }
                    break;
                case "logos": customOptions = {
                    loop: true,
                    nav: false,
                    items: 1,
                    dots: true,
                    margin: 0,
                    stagePadding: 0,
                    responsive: {
                         768: { items: 2 },
                         960: { items: 3},
                         1200: { items: 5 },
                         1650: { items: 6 }
                        }
                    };
                break;                    
                default:
                    customOptions = {
                        items: 1,
                        margin:0,
                        nav: false,
                        dots: true,
                        loop: true,
                        autoHeight:true,
                        stagePadding: 0,
                        navClass: [ 'slider__btn slider__prev', 'slider__btn slider__next' ],
                        responsive : {
                            960 : {
                                dots: false,
                                nav: true,
                            },
                        }
                    }
                    break;
            }

            //Merge the default settings with the custom settings from each slide type
            sliderParams = $.extend(true, defaultOptions, customOptions);

            // Add class based on the type of slider for any extra stying needs
            if(sliderType) {
                $(this).addClass('slider--' + sliderType);   
            } else {
                $(this).addClass('slider--default');
            }

            $(this).on('translated.owl.carousel', function(event) {                
                // Change the aria attributes after the slider has finished animation
                $(this).find('.slider__item').attr('aria-selected','false');
                $(this).find('.slider__item.active').attr('aria-selected','true');
            });
            
            // Call functions to add accessibility once the slider has initialized or changed
            $(this).on('initialized.owl.carousel', function() {
                sliderAccessibility($(this));
            });
            
            // If slider has data-mobile-only init and destroy slider based on breakpoint 
            // otherwise init slider with settings from merge
            if(isMobile !== undefined) {
                sliderMobile($(this), sliderParams);
            } else {
                $(this).owlCarousel(sliderParams);
            }

            // Bind custom buttons to OwlCarousel2 methods
            const customPrevButton = document.querySelector('.slider__prev');
            const customNextButton = document.querySelector('.slider__next');

            if (customPrevButton) {
                customPrevButton.addEventListener('click', function() {
                    console.log('[CLICK] prev.owl.carousel');
                    slider.trigger('prev.owl.carousel');
                });
            }

            if (customNextButton) {
                customNextButton.addEventListener('click', function() {
                    console.log('[CLICK] next.owl.carousel');
                    slider.trigger('next.owl.carousel');
                });
            }
        });
    }
}

export default {
    initSlider : initSlider
}